module.exports = __webpack_public_path__ + "static/media/CRVS.aecbacd9.svg";